var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"skeletonItem"},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1),_vm._l((_vm.quantity),function(item){return _c('div',{key:item},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }